import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { finishSsoLogin, handleSsoCallbackError } from './actions';

class SsoCallback extends PureComponent {
  componentDidMount() {
    const params = new URLSearchParams(this.props.location.search);
    const ssoError = params.get('sso_error');
    const ssoToken = params.get('sso_token');

    if (ssoError) {
      this.props.handleSsoCallbackError(ssoError);
      return;
    }

    if (!ssoToken) {
      this.props.history.replace('/auth');
      return;
    }

    this.props.finishSsoLogin(ssoToken);
  }

  render() {
    return <div>Validando login com Google...</div>;
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  finishSsoLogin,
  handleSsoCallbackError,
}, dispatch);

export default connect(null, mapDispatchToProps)(SsoCallback);
